import { Flex } from '../../flex/flex';
import { Toast } from '../../toast/toast';
import type { ToastProps } from '../../toast/toast.types';

export const renderToast = (toast: ToastProps) => (
  <Flex mb={2} p={2} key={toast.id}>
    <Toast {...toast} />
  </Flex>
);
